import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { XIcon } from "@heroicons/react/solid";
import { useTranslation } from "react-i18next";

import HambergurMenu from "../assets/HambergurMenu.svg";
import flores from "../assets/mar1.jpg";
import logo from "../assets/aldana2.jpg";

const MainNavigation = () => {
  const [showNav, setShowNav] = useState(false);

  const navHandler = () => {
    setShowNav(!showNav);
  };

  const { t, i18n } = useTranslation();

  // 🌍 CAMBIO DE IDIOMA
  const toggleLanguage = () => {
    const newLang = i18n.language === "es" ? "en" : "es";
    i18n.changeLanguage(newLang);
  };

  // LINKS
  const links = [
    {
      name: t("nav.about"),
      path: "/mi-vision",
    },
    {
      name: t("nav.projects"),
      path: "/proyectos",
    },
    {
      name: t("nav.travels"),
      path: "/destinos",
    },
    {
      name: t("nav.reservations"),
      path: "/reservas",
    },
    {
      name: t("nav.mentorships"),
      path: "/mentorias",
    },
  ];

  return (
    <>
      {/* NAVBAR */}
      <div className="fixed top-0 left-0 w-full z-50">
        <div
          className="
            relative
            h-[95px]
            flex
            items-center
            justify-between
            px-4
            sm:px-6
            md:px-10
            overflow-hidden
          "
        >

          {/* BACKGROUND */}
          <img
            src={flores}
            alt="bg"
            className="absolute inset-0 w-full h-full object-cover"
          />

          {/* OVERLAY */}
          <div className="absolute inset-0 bg-[#0E0B09]/60 backdrop-blur-sm" />

          {/* LOGO */}
          <motion.div
            initial={{ x: -40, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="relative z-10 flex-shrink-0 flex items-center"
          >
            <NavLink to="/">
              <img
                src={logo}
                alt="Logo"
                className="
                  w-11 h-11
                  sm:w-12 sm:h-12
                  rounded-full
                  object-cover
                  border border-[#3C2B22]
                  shadow-lg
                "
              />
            </NavLink>
          </motion.div>

          {/* DESKTOP */}
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 4 }}
            transition={{ duration: 0.5 }}
            className="
              hidden
              lg:flex
              flex-1
              justify-center
              items-center
              gap-6
              xl:gap-10
              z-10
            "
          >

            {/* LINKS */}
            <ul
              className="
                flex
                items-center
                text-[#EDE0D0]
                uppercase
                font-light
                whitespace-nowrap
                text-xs
                xl:text-sm
                tracking-[0.2em]
                xl:tracking-[0.3em]
                gap-6
                xl:gap-10
              "
            >
              {links.map((item, i) => (
                <li key={i}>
                  <NavLink
                    to={item.path}
                    className="relative group px-2 py-1"
                  >
                    {item.name}

                    <span
                      className="
                        absolute
                        left-0
                        -bottom-1
                        w-0
                        h-[1px]
                        bg-[#B8977F]
                        transition-all
                        duration-300
                        group-hover:w-full
                      "
                    />
                  </NavLink>
                </li>
              ))}
            </ul>

            {/* 🌍 BOTÓN IDIOMA */}
            <button
              onClick={toggleLanguage}
              className="
                flex
                items-center
                justify-center
                min-w-[52px]
                h-10
                px-3
                rounded-full
                border
                border-[#B8977F]
                bg-[#1A1410]/70
                text-[#EDE0D0]
                hover:bg-[#B8977F]
                hover:text-white
                transition-all
                duration-300
                shadow-lg
                backdrop-blur-md
              "
            >
              <span
                className="
                  text-[11px]
                  tracking-[0.25em]
                  uppercase
                  font-light
                "
              >
                {i18n.language === "es" ? "EN" : "ES"}
              </span>
            </button>
          </motion.div>

          {/* MOBILE */}
          <div className="lg:hidden relative z-10 flex items-center gap-4">

            {/* 🌍 BOTÓN IDIOMA MOBILE */}
            <button
              onClick={toggleLanguage}
              className="
                flex
                items-center
                justify-center
                min-w-[46px]
                h-9
                px-3
                rounded-full
                border
                border-[#B8977F]
                bg-[#1A1410]/70
                text-[#EDE0D0]
                hover:bg-[#B8977F]
                hover:text-white
                transition-all
                duration-300
                backdrop-blur-md
              "
            >
              <span
                className="
                  text-[10px]
                  tracking-[0.22em]
                  uppercase
                  font-light
                "
              >
                {i18n.language === "es" ? "EN" : "ES"}
              </span>
            </button>

            {/* HAMBURGER */}
            <button onClick={navHandler}>
              {showNav ? (
                <XIcon className="w-6 h-6 text-[#EDE0D0]" />
              ) : (
                <img
                  src={HambergurMenu}
                  alt="menu"
                  className="w-6 h-6 invert opacity-80"
                />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* MOBILE MENU */}
      <AnimatePresence>
        {showNav && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.35 }}
            className="
              lg:hidden
              fixed
              top-[95px]
              left-0
              w-full
              z-40
              bg-[#0E0B09]/95
              backdrop-blur-xl
              border-t
              border-[#3C2B22]/40
            "
          >
            <ul
              className="
                flex
                flex-col
                items-center
                py-8
                gap-7
                uppercase
                text-sm
                tracking-[0.25em]
              "
            >
              {links.map((item, i) => (
                <motion.li
                  key={i}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: i * 0.05 }}
                >
                  <NavLink
                    to={item.path}
                    onClick={navHandler}
                    className="relative group text-[#EDE0D0]"
                  >
                    {item.name}

                    <span
                      className="
                        absolute
                        left-0
                        -bottom-1
                        w-0
                        h-[1px]
                        bg-[#B8977F]
                        transition-all
                        duration-300
                        group-hover:w-full
                      "
                    />
                  </NavLink>
                </motion.li>
              ))}
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default MainNavigation;